import { buildBookingUrl } from './components/VehicleSelecter/VehicleSelecter.utils';
import { useTrackCTA } from '../../../utils/Tracking/CtaClick/TrackCtaClick';

// Booking type is used to construct the booking url for workshop products.
export const WORKSHOP_INTERNAL_PRODUCT_MAP: Record<string, { bookingType: 'service' | 'repairment' }> = {
  '1': { bookingType: 'repairment' },
  '2': { bookingType: 'service' },
};

interface OnSelectedVehicleClickProps {
  licensePlateNumber?: string;
  trackCTA: ReturnType<typeof useTrackCTA>;
  workshopBookingLink: string;
  centerId?: number;
  bookingType?: 'service' | 'repairment';
  skipCtaTracking?: boolean;
}

export const handleSelectedVehicleClick = ({
  licensePlateNumber,
  trackCTA,
  workshopBookingLink,
  centerId,
  bookingType,
  skipCtaTracking,
}: OnSelectedVehicleClickProps): string | undefined => {
  if (!licensePlateNumber) return undefined;
  if (!skipCtaTracking) {
    trackCTA({ cta_position: 'content', text: 'Be om tilbud' });
  }

  const bookingUrl = buildBookingUrl({
    baseUrl: workshopBookingLink,
    registration: licensePlateNumber,
    centerId,
    nafCenterProductType: bookingType,
  });

  window.open(bookingUrl, '_blank');
  return bookingUrl;
};
